import request from '@/utils/request'

let DiscountApi = {

  /*折扣方案列表*/
  list(data) {
    return request._post('/shop/plus.discount.Index/index', data);
},
/*添加折扣方案*/
add(data) {
    return request._post('/shop/plus.discount.Index/add', data);
},
/*修改折扣方案*/
edit(data) {
    return request._post('/shop/plus.discount.Index/edit', data);
},
/*删除折扣方案*/
del(data) {
    return request._post('/shop/plus.discount.Index/del', data);
},
/*折扣方案详情*/
detail(data) {
  return request._post('/shop/plus.discount.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.discount.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.discount.Setting/getSetting', data, errorback);
    },
}
export default DiscountApi;



// WEBPACK FOOTER //
// ./src/api/discount.js